import * as swcHelpers from '@swc/helpers';
import { validateResponse, unwrapResponse } from '../response.js';
import { acceptJson, authHeader, postJson } from '../shared.js';
import { personalDetailsResponseSpec } from './specs.js';

function details(apiUrl, accessToken, customerId) {
    return _details.apply(this, arguments);
}
function _details() {
    _details = swcHelpers.asyncToGenerator(function*(apiUrl, accessToken, customerId) {
        return validateResponse(personalDetailsResponseSpec, (yield fetch(`${apiUrl}/customers/customer/${encodeURIComponent(customerId)}/details`, {
            method: 'GET',
            headers: swcHelpers.objectSpread({}, acceptJson, authHeader(accessToken))
        })));
    });
    return _details.apply(this, arguments);
}
function updateDetails(apiUrl, accessToken, customerId, request) {
    return _updateDetails.apply(this, arguments);
}
function _updateDetails() {
    _updateDetails = swcHelpers.asyncToGenerator(function*(apiUrl, accessToken, customerId, request) {
        return unwrapResponse((yield fetch(`${apiUrl}/customers/customer/${encodeURIComponent(customerId)}/details`, {
            method: 'POST',
            headers: swcHelpers.objectSpread({}, acceptJson, postJson, authHeader(accessToken)),
            body: JSON.stringify(request)
        })));
    });
    return _updateDetails.apply(this, arguments);
}

export { details, updateDetails };
//# sourceMappingURL=details.js.map
